export default __webpack_public_path__ + "static/media/kampeerterrein.80cdf471.svg";